import React from 'react';

import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

function CategorySkeleton() {
  return (
    <Card className="group grid h-[168px] cursor-pointer grid-rows-12 rounded-lg border-none  transition-all  sm:h-[272px]">
      <Skeleton className="grid-2 row-span-8 size-full  object-cover object-center" />
      <Skeleton className="row-span-4 flex h-full items-center justify-between px-3 py-2">
        <Skeleton className=" flex flex-col justify-center text-sm">
          <Skeleton />
          <Skeleton />
        </Skeleton>
        <Skeleton />
      </Skeleton>
    </Card>
  );
}

export function CategorySkeletonList(props: { count: number }) {
  return (
    <>
      {Array.from({ length: props.count }, (_, index) => (
        <CategorySkeleton key={index.toString()} />
      ))}
    </>
  );
}

export default CategorySkeleton;
